import { useRef, useEffect, useContext } from 'react'
import { useNow } from '../../../componentsF/hooksF/useNowF.jsx'
import { getMyTurnRemainDur, shouldNagPlayer } from '../../sharedF/getMyTurnRemainDurF.mjs'
import { gameStateMsToLux } from '../../sharedF/gameStateMsToLuxAI.mjs'
import { GameContext } from '../GameContextF.jsx'

export const useAutoSubmit = ({ hasContent, doSubmit }) => {
  const hasAutoSubmittedRef = useRef(false)
  const { now } = useNow()
  const { myState: { publicState }, publicStates, settings } = useContext(GameContext)
  const { gameActiveAt, myTaskName } = gameStateMsToLux(publicState)
  
  useEffect(() => {
    if (hasAutoSubmittedRef.current) return
    if (settings?.disableTurnTimers) return
    if (!gameActiveAt || !myTaskName || myTaskName === 'WaitingTask') return
    if (!hasContent) return
    if (!shouldNagPlayer({ activePlayerCount: Object.keys(publicStates).length })) return
    
    const { remainDur } = getMyTurnRemainDur({ myTaskName, gameActiveAt, now })
    
    if (remainDur.as('seconds') <= 0) {
      hasAutoSubmittedRef.current = true
      doSubmit()
    }
  }, [now, hasContent, doSubmit, myTaskName, gameActiveAt])
  
  // Reset when task changes (new assignment)
  useEffect(() => {
    hasAutoSubmittedRef.current = false
  }, [myTaskName, gameActiveAt?.toMillis()])
}
